/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedMutation<InputType, OutputType> = string & {
  __generatedMutationInput: InputType;
  __generatedMutationOutput: OutputType;
};

export const addUserRestaurant = /* GraphQL */ `mutation AddUserRestaurant($restaurantId: ID!) {
  addUserRestaurant(restaurantId: $restaurantId)
}
` as GeneratedMutation<
  APITypes.AddUserRestaurantMutationVariables,
  APITypes.AddUserRestaurantMutation
>;
export const addUserRestaurants = /* GraphQL */ `mutation AddUserRestaurants($restaurantIds: [ID]!) {
  addUserRestaurants(restaurantIds: $restaurantIds)
}
` as GeneratedMutation<
  APITypes.AddUserRestaurantsMutationVariables,
  APITypes.AddUserRestaurantsMutation
>;
export const findRestaurantFromUrl = /* GraphQL */ `mutation FindRestaurantFromUrl($url: String!) {
  findRestaurantFromUrl(url: $url) {
    id
    name
    platform
    __typename
  }
}
` as GeneratedMutation<
  APITypes.FindRestaurantFromUrlMutationVariables,
  APITypes.FindRestaurantFromUrlMutation
>;
export const removeUserRestaurant = /* GraphQL */ `mutation RemoveUserRestaurant($restaurantId: ID!) {
  removeUserRestaurant(restaurantId: $restaurantId)
}
` as GeneratedMutation<
  APITypes.RemoveUserRestaurantMutationVariables,
  APITypes.RemoveUserRestaurantMutation
>;
export const submitOnboarding = /* GraphQL */ `mutation SubmitOnboarding(
  $job: String!
  $numberOfLocations: String!
  $businessObjectives: [String]!
) {
  submitOnboarding(
    job: $job
    numberOfLocations: $numberOfLocations
    businessObjectives: $businessObjectives
  )
}
` as GeneratedMutation<
  APITypes.SubmitOnboardingMutationVariables,
  APITypes.SubmitOnboardingMutation
>;
export const skipOnboarding = /* GraphQL */ `mutation SkipOnboarding {
  skipOnboarding
}
` as GeneratedMutation<
  APITypes.SkipOnboardingMutationVariables,
  APITypes.SkipOnboardingMutation
>;
export const createCheckoutSession = /* GraphQL */ `mutation CreateCheckoutSession(
  $priceId: ID!
  $quantity: Int
  $setup: Boolean
  $isLocalhost: Boolean
) {
  createCheckoutSession(
    priceId: $priceId
    quantity: $quantity
    setup: $setup
    isLocalhost: $isLocalhost
  ) {
    clientSecret
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateCheckoutSessionMutationVariables,
  APITypes.CreateCheckoutSessionMutation
>;
export const updateSubscriptionPrice = /* GraphQL */ `mutation UpdateSubscriptionPrice($priceId: ID!, $quantity: Int) {
  updateSubscriptionPrice(priceId: $priceId, quantity: $quantity)
}
` as GeneratedMutation<
  APITypes.UpdateSubscriptionPriceMutationVariables,
  APITypes.UpdateSubscriptionPriceMutation
>;
export const previewSubscriptionPrice = /* GraphQL */ `mutation PreviewSubscriptionPrice($priceId: ID!, $quantity: Int) {
  previewSubscriptionPrice(priceId: $priceId, quantity: $quantity) {
    amountDue
    total
    totalExcludingTax
    endingBalance
    periodStart
    periodEnd
    __typename
  }
}
` as GeneratedMutation<
  APITypes.PreviewSubscriptionPriceMutationVariables,
  APITypes.PreviewSubscriptionPriceMutation
>;
export const unsubscribe = /* GraphQL */ `mutation Unsubscribe {
  unsubscribe
}
` as GeneratedMutation<
  APITypes.UnsubscribeMutationVariables,
  APITypes.UnsubscribeMutation
>;
export const createFavoriteList = /* GraphQL */ `mutation CreateFavoriteList($name: String!) {
  createFavoriteList(name: $name) {
    id
    name
    restaurantCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateFavoriteListMutationVariables,
  APITypes.CreateFavoriteListMutation
>;
export const deleteFavoriteList = /* GraphQL */ `mutation DeleteFavoriteList($favoriteListId: ID!) {
  deleteFavoriteList(favoriteListId: $favoriteListId)
}
` as GeneratedMutation<
  APITypes.DeleteFavoriteListMutationVariables,
  APITypes.DeleteFavoriteListMutation
>;
export const addRestaurantsToFavoriteList = /* GraphQL */ `mutation AddRestaurantsToFavoriteList(
  $favoriteListId: ID!
  $restaurantIds: [ID]!
) {
  addRestaurantsToFavoriteList(
    favoriteListId: $favoriteListId
    restaurantIds: $restaurantIds
  )
}
` as GeneratedMutation<
  APITypes.AddRestaurantsToFavoriteListMutationVariables,
  APITypes.AddRestaurantsToFavoriteListMutation
>;
export const removeRestaurantFromFavoriteList = /* GraphQL */ `mutation RemoveRestaurantFromFavoriteList(
  $favoriteListId: ID!
  $restaurantId: ID!
) {
  removeRestaurantFromFavoriteList(
    favoriteListId: $favoriteListId
    restaurantId: $restaurantId
  )
}
` as GeneratedMutation<
  APITypes.RemoveRestaurantFromFavoriteListMutationVariables,
  APITypes.RemoveRestaurantFromFavoriteListMutation
>;
export const updateFavoriteList = /* GraphQL */ `mutation UpdateFavoriteList($favoriteListId: ID!, $name: String!) {
  updateFavoriteList(favoriteListId: $favoriteListId, name: $name) {
    id
    name
    restaurantCount
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateFavoriteListMutationVariables,
  APITypes.UpdateFavoriteListMutation
>;
export const markNotificationAsRead = /* GraphQL */ `mutation MarkNotificationAsRead($notificationId: ID!) {
  markNotificationAsRead(notificationId: $notificationId)
}
` as GeneratedMutation<
  APITypes.MarkNotificationAsReadMutationVariables,
  APITypes.MarkNotificationAsReadMutation
>;
export const refreshRestaurants = /* GraphQL */ `mutation RefreshRestaurants($restaurantIds: [ID]!) {
  refreshRestaurants(restaurantIds: $restaurantIds)
}
` as GeneratedMutation<
  APITypes.RefreshRestaurantsMutationVariables,
  APITypes.RefreshRestaurantsMutation
>;
export const createGrid = /* GraphQL */ `mutation CreateGrid(
  $name: String!
  $restaurantIds: [ID]!
  $columns: [String]!
) {
  createGrid(name: $name, restaurantIds: $restaurantIds, columns: $columns) {
    id
    name
    columns
    restaurantCount
    emails
    frequency
    __typename
  }
}
` as GeneratedMutation<
  APITypes.CreateGridMutationVariables,
  APITypes.CreateGridMutation
>;
export const updateGrid = /* GraphQL */ `mutation UpdateGrid(
  $gridId: ID!
  $name: String!
  $restaurantIds: [ID]!
  $columns: [String]!
  $emails: [String]
  $frequency: ExportFrequency
) {
  updateGrid(
    gridId: $gridId
    name: $name
    restaurantIds: $restaurantIds
    columns: $columns
    emails: $emails
    frequency: $frequency
  ) {
    id
    name
    columns
    restaurantCount
    emails
    frequency
    __typename
  }
}
` as GeneratedMutation<
  APITypes.UpdateGridMutationVariables,
  APITypes.UpdateGridMutation
>;
export const deleteGrid = /* GraphQL */ `mutation DeleteGrid($gridId: ID!) {
  deleteGrid(gridId: $gridId)
}
` as GeneratedMutation<
  APITypes.DeleteGridMutationVariables,
  APITypes.DeleteGridMutation
>;
export const createExport = /* GraphQL */ `mutation CreateExport($gridId: ID!) {
  createExport(gridId: $gridId)
}
` as GeneratedMutation<
  APITypes.CreateExportMutationVariables,
  APITypes.CreateExportMutation
>;
export const newExport = /* GraphQL */ `mutation NewExport($username: String!, $url: String!) {
  newExport(username: $username, url: $url) {
    username
    url
    __typename
  }
}
` as GeneratedMutation<
  APITypes.NewExportMutationVariables,
  APITypes.NewExportMutation
>;
